/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Hidden, Link as MuiLink, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';

import {
  StyledCard,
  StyledCenteredSkeleton,
  StyledDesktopSkeleton,
  StyledMobileSkeleton,
  StyledNote,
  StyledTitle,
} from './styles';

const DescriptionSkeleton = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledCard>
      <StyledCenteredSkeleton>
        <StyledTitle variant="h3">
          Nulla duis do sint nisi excepteur voluptate
        </StyledTitle>
      </StyledCenteredSkeleton>

      {/* Mobile */}
      <Hidden mdUp>
        <StyledMobileSkeleton variant="rect">
          <Typography variant="caption">
            {t('challenges.declaration.readMore')}
          </Typography>
          <ExpandMoreIcon fontSize="large" />
        </StyledMobileSkeleton>
      </Hidden>

      {/* Desktop */}
      <Hidden smDown>
        <StyledCenteredSkeleton>
          <MuiLink>{t('challenges.declaration.seeDetail')}</MuiLink>
        </StyledCenteredSkeleton>
        <StyledDesktopSkeleton variant="rect">
          <Typography>
            Consequat id nulla consequat ipsum duis irure consequat esse do ex
            dolore. Et enim sint ad ut minim eu ad nulla. Et voluptate ad magna
            voluptate quis ullamco. Aute aute est ex dolore duis.
          </Typography>
        </StyledDesktopSkeleton>
      </Hidden>

      <StyledCenteredSkeleton>
        <StyledNote>
          {t('challenges.declaration.declareToParticipate').toUpperCase()}
        </StyledNote>
      </StyledCenteredSkeleton>
    </StyledCard>
  );
};

export default DescriptionSkeleton;
